import styled from 'styled-components';

export const FBTStyled= styled.div`

.plus-icon {
  width: 20px;
  height: 38px;
}
.main-product-wrapper {
  display: flex;
  align-items: center;
  padding-top: 24px;
  width: 100%;
  background-color: white;
  padding-bottom:24px

}

.main-product-img {
  position: relative;
  
}

.main-product-img img {
  width: 68px;
  height: 68px;
  margin-left: 18px;
  border: 1px solid #D0DAE4;
  border-radius: 8.5px;
  overflow: hidden;
  padding: 10px;
}

.main-product-name {
  font-size: 15px;
  font-weight: 600;
  padding-left: 12px;
  padding-bottom: 2px;
  line-height: 18px;
  width: 72%;


  .union-logo {
    padding-top: 8px;
    display: flex;

    .tick_added {
      display: flex;
      align-items: center;
      margin-left: 6px;
      color: #388e3c;
    }
  }
}

.btn.btn-sm{
  padding: 7px 11px;
}
.add-to-card {
    position: absolute;
    bottom:0;
    top: ${(props)=>(props?.upSellingFbt ? '178px' : 'none' )};
    right:0;
    .cart-icon {
      width: 40px !important;
      height: 40px !important;
    }
    .disabled-cart {
      width: 80px !important;
      height: 32px !important;
      margin-bottom:0;
      margin-right:0;
    }
    .col-lg-12 {
      padding-left: 0;
    }
    .quantity-wrapper {
      position: relative;
      margin-bottom: 6px;
      margin-right: 4px;
      .txtLoading {
        .dropdown-wrapper {
          &.dropdown {
            .dropdown-toggle {
              font-size: 11px;
            }
          }
        }
      }
      .dropdown-wrapper {
        &.dropdown {
          .dropdown-toggle {
            text-align: center;
            font-weight: 700;
            font-size: 17px;
            color: ${(props) => props.theme.green.dark};
            border:1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
            border-radius: 100px;
            width: 84px;
            height: 32px;
            padding: 4px 30px 4px 30px;
            &:after {
              display: none;
            }
          }
          .dropdown-menu {
            &.show {
              a {
                display: none;
              }
            }
          }
        }
      }
      .decrease-product {
        width: 28px;
        position: absolute;
        top: 2px;
        left: 2px;
        cursor: pointer;
      }
      .increase_product {
        width: 28px;
        position: absolute;
        top: 2px;
        right: 2px;
        cursor: pointer;
      }
    }
  }
.divider {
    width: 452px;
    height: 1px;
    background: ${(props) => props.theme.color.borderLight};
  }

.fbt-container {
    width: ${(props)=>(props?.upSellingFbt ? '100%' : '86%' )};
    background: ${(props) => props?.theme?.color?.white};
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;


    > .fbt-cart-btn.buy-button {
      padding: 2px 16px 16px;

      > .btn.btn-sm {
        width: 93% !important;
        font-size: 16px;
        padding: 18px;
        font-weight: 700;
        line-height: 18px;
        margin-left: 16px;
      }

      > .btn.btn-sm.fbtLoadingText {
        background: ${(props) => props?.theme?.color?.white} !important;
        color: ${(props) => props?.theme?.green?.dark} !important;
        border: 1px solid ${(props) => props?.theme?.green?.dark} !important;
        opacity: 0.9 !important;
        font-size: 16px;
        font-weight: 700;
      }

      .btn.disabled, .btn:disabled {
        background: ${(props) => props.theme.grey.grey4D} !important;
        border-color: ${(props) => props.theme.grey.grey4D} !important;
        color: ${(props) => props?.theme?.text?.medium} !important;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        opacity: 0.7;
      }
    }

    .fbt-title {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 0;
      padding: 20px 16px 16px;
      line-height: 23px;
      border-bottom: 1px solid ${(props) => props?.theme?.color?.borderLight};
    }

    .fbt-product-container {
      display: flex;
      flex-direction: row;
      align-items: inherit;
      padding: 16px 16px 16px 16px;
      overflow-x:scroll;
          scrollbar-width: thin;
          scrollbar-color: transparent transparent;
          &::-webkit-scrollbar {
              display: none;
              }
          &::-moz-scrollbar {
             display: none;
              }
      justify-content: center;
      width: 100%;

      .fbt-product {
        border-radius: 8px;
        border: 1px solid ${(props) => props?.theme?.color?.borderLight};
        background: ${(props) => props?.theme?.color?.white};
        display: flex;
        flex-direction: column;
        padding: 6px;
        position: relative;
        width: 124px;
        padding-bottom: ${(props)=>(props?.upSellingFbt ? '30px' : '7px' )};
        .fbt_add{
          min-height: 177px;

        > a {
          text-decoration: none;
          color: inherit;
        }

        p {
          font-size: 12px;
          font-weight: 600;
          margin:3px;
          height: 44px;
          overflow: hidden;
          line-height: 15.06px; 
          word-break: break-all;
        }

        .fbt_checkbox{
          position: absolute;
          top: 6px;
          left: 6px;
          z-index: 1;

          .form-check .form-check-input[type='checkbox'] {
            background-color: ${(props) => props?.theme?.color?.white};
            width: 24px;
            min-width: 24px;
            height: 24px;
          }
        }

        .fbt_checkbox + div{
          width: 100%;
          display: flex !important;
          justify-content: center;
          padding: 0 0 25px;
        }
        
        .price-label {
          display: flex;
          flex-direction: column; 
          align-items: flex-start;

          .btn-outline-success {
            height: 30px;
          }
          .btn.btn-sm {
            font-size: 14px;
            line-height: 10px;
            padding: 0px;
          }
          .addToCartButtonWrapper {
            width: 100%;
            display: flex;

            .isFloat {
              width: 100%;
            }

            .btn-outline-success {
              width: 110px;
              height: 38px;
            }
          }

          > span {
            font-size: 13px;
            font-weight: 700;
            line-height: 20px;
            overflow-wrap: break-word;
            max-width: 100%;
          }

          > del {
            font-weight: 600;
            font-size: 10px;
            line-height: 20px;
            color: ${(props) => props?.theme?.text?.medium};
            overflow-wrap: break-word;
            max-width: 100%;
            min-height: 10px;
          }
        }
      }

      .fbt-product.failedToAdd {
        border: 1px solid ${(props) => props?.theme?.color?.red};
        background: ${(props) => props?.theme?.verification?.red.off};
      }

      .fbt-product-separator {
        font-size: 22px;
        font-weight: 700;
        align-self: center;
      }
    }
    }
  }
  
  @media (max-width: 420px) {

    .divider {
    width: 100%;
    height: 1px;
    background: ${(props) => props.theme.color.divider};
  }

    .plus-icon {
       width: 18px;
       height: 38px;
  }

    .main-product-name {
}
  .fbt-container{
    .fbt-product-container{
       padding: ${(props)=>(props?.fbt2Product ? '18px 57px 16px 68px' : '16px 10px 16px 16px')};
        .fbt-product{
            width: 124px;
            .price-label{
              .order-wrapper{
                .addToCartButtonWrapper{
                  .btn-outline-success{
                    width: 100%;
                  }
                }
              }
            }
        }
    }
  }
  .fbt-container{
    .fbt-product-container{
        .fbt-product{
        
            .price-label{
                .addToCartButtonWrapper{
                  .btn-outline-success{
                    width: 100%;
                    font-size:13px;
                  }
                }
            }
        }
    }
  }

  }
  @media (max-width: 420px) {

    .main-product-wrapper {
      display: flex;
      justify-content: left;
      margin-right: 81px;
      width: 92%;
    }
    .fbt-container{
      .fbt-cart-btn.buy-button{
        > .btn.btn-sm {
        width: 85% !important;
        font-size: 16px;
        padding: 18px;
        font-weight: 700;
        line-height: 18px;
        margin-left: 19px;
      }
      }
    }
  }




  `;